<template>
  <div class="privacy_policy section">
    <div class="columns">
      <div class="column is-three-fifths-desktop is-offset-one-fifth-desktop">
        <h1 class="subtitle">えるかつ！プライバシーポリシー</h1>
        <p class="block">１．個人情報の収集<br>
        個人情報とは、個人に関する情報であり、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるもの、顔認識データ等個人識別符号を含む。）を指します。</p>
        <p class="block">
          当社（株式会社シトラスウインズ）は、個人情報を収集することがあります。なお当社は、その情報単体では個⼈情報に該当しない属性情報（年齢・性別・職業・居住地域等）、Cookie、IPアドレス、位置情報、広告識別⼦（AAID・IDFA等）、サービス利用履歴といったインターネットの利⽤に係るログ情報等の個⼈に関する情報（以下総称して「個人関連情報」といいます）を収集することがあります。お客様が当社サービスの利⽤にあたり当社に個⼈情報を提供した場合、当社は当該情報と当該お客様の個人関連情報を紐付ける場合がありますが、この場合には当該個人関連情報も個⼈情報として取り扱います。
        </p>
        <p class="block">
          ２．個人情報の利用目的<br>当社は、収集した個人情報を以下の目的で利用することができるものとします。
        </p>
        <div class="content">
          <ul>
            <li>弊社が運営するコンテンツ配信機能の提供のため、お客様の登録情報、サービス利用状況等を利用すること。</li>
            <li>キャスト給与の計算、獲得ポイントの計算のため、お客様の登録情報、当社サービス利用状況等を利用すること。</li>
            <li>当社及び第三者の商品等（旅行、保険その他の金融商品を含む。以下同じ。）の販売、販売の勧誘、発送、サービス提供のため</li>
            <li>当社及び第三者の商品等の広告または宣伝（ダイレクトメールの送付、電子メールの送信を含む。）のため<br>例として以下の利用が含まれます。</li>
            <li>当社サービスに関するメールマガジン・ダイレクトメール・お知らせ・広告等の情報提供のため、お客様の情報やサービスのご利用状況等を利用すること。</li>
            <li>個々のお客様のニーズに即したより適切な広告が表示されるように、お客様の位置情報を利用、分析すること。</li>
            <li>料金請求、課金計算のため</li>
            <li>本人確認、認証サービスのため<br>例として以下の利用が含まれます。</li>
            <li>ログインの際に、同じお客様からのログインかどうかを確認するため、ユーザーID、パスワードその他お客様の登録情報を利用すること。</li>
            <li>本人確認が必要な一部のサービス等をご利用いただく場合や、お客様からのお問い合わせを受けお客様の本人確認を行う場合に、氏名、生年月日、住所、電話番号、銀行口座番号、クレジットカード番号等の情報を利用すること。</li>
            <li>アフターサービス、問い合わせ、苦情対応のため<br>例として、お客様からのご意⾒、お問合せ、通報、その他のやりとりに対応する場合に、お客様の情報やサービスのご利用状況等を利用することがあります。</li>
            <li>アンケートの実施のため<br>
            例として、アンケート調査、モニター調査を実施するためにお客様の情報やサービスのご利用状況等を利用することがあります。</li>
            <li>懸賞、キャンペーンの実施のため</li>
            <li>マーケティングデータの調査、統計、分析のため<br>
              例として、検索キーワード、閲覧されたウェブページ、配信、コンテンツ、購入された商品等お客様の趣向を広告事業者、情報分析事業者に提供し、同事業者のシステムを用いて調査、統計化、分析することがあります。<br>
            ※当社が広告関連事業者、情報分析事業者に分析業務を委託する場合、当社が保有する個⼈情報に当該広告関連事業者等が保有するお客様の属性情報や⾏動履歴といったインターネットの利⽤にかかるログ情報を付加して、当該情報のみでは当社において特定の個⼈を識別することができない情報に集計した分析結果を受領することがあります。</li>
            <li>新サービス、新機能の開発のため<br>
            例として以下の利用が含まれます。</li>
            <li>お客様の当社サービスの利⽤状況の分析結果を踏まえた当社サービスの改善を行う場合に、お客様の情報やサービスのご利用状況等を利用することがあります</li>
            <li>新規サービスの開発お客様からのお問い合わせへの対応品質の改善を実施する場合に、お客様の情報やサービスのご利用状況等を利用することがあります</li>
            <li>システムの維持、不具合対応のため<br>
            例として以下の利用が含まれます。</li>
            <li>通信環境の改善やその公表に向けた参考資料とするために、お客様のご利用環境情報を携帯電話事業者に提供する場合があります。</li>
            <li>ライブストリーミング配信の視聴、配信環境の改善のため、お客様の情報やサービスのご利用状況等を利用することがあります。</li>
            <li>その他当社の各サービスにおいて個別に定める目的のため</li>
          </ul>
        </div>
        <p class="block">
          ３．個人情報の提供<br>
          当社は、以下に定める場合には、個人情報を第三者に提供することができるものとします。
        </p>
        <div class="content">
          <ul>
            <li>本人の同意がある場合</li>
            <li>当社が行う業務の全部または一部を第三者に委託する場合</li>
            <li>当社に対して秘密保持義務を負う者に対して開示する場合</li>
            <li>当社の権利行使に必要な場合</li>
            <li>合併、営業譲渡その他の事由による事業の承継の際に、事業を承継する者に対して開示する場合</li>
            <li>個人情報保護法その他の法令により認められた場合</li>
            <li>その他当社の各サービスにおいて個別に定める場合</li>
          </ul>
        </div>
        <p class="block">
          ４．リンク先等の個人情報の取扱い<br>
          当社運営サイト上やメールマガジンにおいて、外部のサイトへのリンクが貼られることがあります。この外部のサイトで登録される個人情報は、当社で管轄する情報ではない為、一切の責任を負うことができません。 外部サイトで個人情報を登録される場合は、そのサイトのプライバシーポリシーをご確認ください。
        </p>
        <p class="block">
          ５．個人情報を保護するための体制について<br>
          当社は、個人情報保護法及びプライバシーポリシーに従い、個人情報を適切に取り扱います。個人情報を適切に取り扱うため、以下の安全管理措置を実施し、個人情報を処理する情報システムの安全を確保します。
        </p>
        <div class="content">
          <ul>
            <li>情報管理責任者を設置する。</li>
            <li>個人情報管理委員会を設置し、個人情報の取扱いに関する方針を決定し、運用状況を確認すると共に、情報管理統括者を配置し、その者が個人情報の適切な管理を指導する。</li>
            <li>個人情報を取り扱う担当役員が、取り扱う個人情報の範囲を明確化し、個人情報保護法や関連する社内規程に違反している事実又は兆候を把握した場合の責任者への報告体制を整備する。</li>
            <li>個人情報の取扱いに関する留意事項について、従業者に定期的な教育を実施し、従業者の入社時には個人情報保護に関する研修を実施する。</li>
            <li>アクセス制限により、個人情報を取り扱う従業者及び個人情報データベース等の範囲を限定する。</li>
            <li>当社が個人情報の取り扱いを第三者に委託する場合、当社が定める委託先選定基準を満たす者に委託し、委託先と契約を締結して委託先による業務を適切に管理する。</li>
          </ul>
        </div>
        <p class="block">
          個人情報の漏えい等の事故が発生した場合、当社は、個人情報保護法及び関連するガイドラインに従い、監督官庁へ報告し、当該監督官庁の指示に従い、類似事案の発生防止措置、再発防止措置等の必要な対応を行います。
        </p>
        <p class="block">
          ６．プライバシーポリシーの更新<br>
          当社は、プライバシーポリシーを変更する場合があります。 プライバシーポリシーに重要な変更がある場合には、サイト上で告知します。本ページを都度ご確認の上、当社のプライバシーポリシーをご理解いただくようお願いします。
        </p>
        <p class="block">
          ７．個人情報の訂正及び利用停止等<br>
          当社は、お客様から個人情報が真実でないという理由によって個人情報保護法の定めに基づきその内容の訂正を求められた場合及び予め公表された利用目的の範囲を超えて取り扱われているという理由又は偽りその他不正の手段により収集されたものであるという理由により、個人情報保護法の定めに基づきその利用の停止を求められた場合には、お客様ご本人からの請求であることを確認の上で遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正又は利用停止を行い、その旨をお客様に通知します。なお、訂正又は利用停止を行わない旨の決定をしたときは、お客様に対しその旨を通知いたします。<br>
          当社は、お客様からお客様の個人情報について消去を求められた場合、当社が当該請求に応じる必要があると判断した場合は、お客様ご本人からの請求であることを確認の上で、個人情報の消去を行い、その旨をお客様に通知します。<br>
          個人情報保護法その他の法令により、当社が訂正等又は利用停止等の義務を負わない場合、これらの規定は適用されません。
        </p>
        <p class="block">
          ８．準拠法及び言語<br>
          本プライバシーポリシーに関する準拠法は日本法とし、他の言語と矛盾抵触する場合は日本語が優先されます。
        </p>
        <p class="block">
          ９．質問及び苦情処理の窓口<br>
          当社の個人情報に関する取扱い、プライバシーポリシーに関するご質問、ご相談、その他のお問い合わせにつきましては、えるかつ！サービス内のお問合せフォームよりご連絡ください。
        </p>
        <p class="block">
          ※お客様へのお願い<br>
          当社が運営するえるかつ！では、お客様の登録情報をID・パスワードで保護しています。ID・パスワードの管理は、お客様ご自身が責任を持って行ってください。<br>
          当社が運営するサービスを安全にご利用いただけるよう、当社運営サイト上に、他の方やお客様ご自身の個人情報は掲載されないようお願いいたします。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
};
</script>

<style lang="scss" scoped>
  .privacy_policy {
    font-size: $size-6-5;
  }
</style>
